import {TableProps} from "antd";
import {LoggedEvent} from "../../../models/LoggedEvent";
import React from "react";
import {BasicTable} from "../../Common/BasicComponents/BasicTable";
import {AdminHttpService} from "../../../services/Http/SearchTableService";
import {FilterString} from "../../Common/BasicComponents/filters/FilterString";
import {FilterDate} from "../../Common/BasicComponents/filters/FilterDate";
import {PageTitle} from "../../Common/PageTitle/PageTitle";

export interface AdminEventLogsProps {

}

export type AnyObject = Record<string, any>; // A common definition for a generic object

export function AdminEventLogsPage<T extends AnyObject>(props:AdminEventLogsProps) {
    const columns: TableProps<LoggedEvent>['columns'] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Nome utente',
            dataIndex: 'eclaimUsername',
            key: 'eclaimUsername'
        },
        {
            title: 'Tipo di operazione',
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: 'Descrizione',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Data di creazione',
            dataIndex: 'createdAt',
            key: 'createdAt' ,
            render: (timestamp) => {
                const date = new Date(timestamp * 1000);
                return date.toLocaleDateString();
            },
        }
    ]

    const searchFilters =[
        <FilterString dataKey={"eclaimUsername"} placeholder={"Nome utente"}></FilterString>,
        <FilterString dataKey={"type"} placeholder={"Tipo di operazione"}></FilterString>,
        <FilterString dataKey={"description"} placeholder={"Descrizione"}></FilterString>,
        <FilterDate dataKey={"createdAt"} placeholder={"Data di creazione"}></FilterDate>
    ]


    return <>
        <PageTitle title={"Carica Eventi Registrati"}></PageTitle>
        <BasicTable<LoggedEvent>
            columns={columns}
            urlPath={AdminHttpService.URL_ADMIN_LOGGED_EVENT}
            filters={searchFilters}
        />
    </>

}